export function defaultTransition(
    propToAnimate: string = 'all',
    timeInMs: number = 300
) {
    return `${propToAnimate} ${timeInMs}ms cubic-bezier(0.215, 0.61, 0.355, 1)`
}

export const easeOutQuad = 'all 300ms cubic-bezier(0.25, 0.46, 0.45, 0.94)'
